module.exports = __webpack_public_path__ + "img/digital-ocean.2c01da36.svg";